import redirect from 'src/utils/redirect'
import type { HeaderTownSearchResult } from 'src/layouts/core-layout/components/CoreHeader/composables/useHeaderTownSearch'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore, useURLStore } from 'src/store'

export default function useHeaderTownRedirect() {
  const { reverseFull, reverseFullL10N } = useURLStore()
  // @ts-ignore
  const { urlLang }: ContextStore = useContextStore()

  function getTownUrl(translit: string): string {
    const l10nUrl = reverseFullL10N({
      name: 'town',
      args: {
        town_translit: translit,
        language: urlLang,
      },
    })

    if (l10nUrl) {
      return l10nUrl
    }

    return reverseFull({ name: 'town', args: [translit] }) || ''
  }

  function redirectToTown(town: Pick<HeaderTownSearchResult, 'translit'>) {
    const path = getTownUrl(town.translit)

    if (!path) {
      return
    }

    redirect({ path })
  }

  return {
    redirectToTown,
  }
}
